<template>
  <section class="flex pt-6 px-5 pb-5 border rounded border-grey-500">
    <div class="mr-12 w-full">
      <h2 class="text-black-900 text-2xl font-medium mb-4">
        {{ shortlist.name }}
      </h2>
      <ul class="space-y-3">
        <li class="bg-grey-400 pt-4 px-5 pb-5 hover:shadow-sm">
          <div class="flex items-center justify-between mb-5">
            <router-link
              to="/shortlist/1/catalogs/"
              class="
                flex
                items-center
                font-medium
                text-lg
                group
                hover:text-orange-900
              "
            >
              Shortlist of Catalogs
              <span
                class="
                  mx-2
                  py-0.5
                  px-0.7
                  leading-none
                  rounded-xl
                  bg-black-900
                  text-white-900 text-xs
                  group-hover:bg-orange-900
                "
              >
                15
              </span>
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 9L5 5L1 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>

            <base-button colorScheme="orange" class="py-2 max-w-100">
              <span class="font-normal text-sm"> Export </span>
            </base-button>
          </div>
          <ul class="space-x-3 flex items-start">
            <li v-for="(catalog, i) of catalogData" :key="i">
              <router-link class="block w-28" to="/">
                <div class="mb-1 w-18 min-h-115">
                  <img
                    :src="catalog.imageURl"
                    :alt="catalog.name"
                    class="shadow-md h-auto"
                  />
                </div>

                <h3
                  class="
                    text-sm text-black-900
                    font-medium
                    mb-2
                    hover:text-orange-900
                  "
                >
                  {{ catalog.name }}
                </h3>

                <div
                  class="
                    flex
                    items-center
                    uppercase
                    font-medium
                    text-grey-700 text-sm
                  "
                >
                  <svg
                    class="mr-1"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.996 3.32949L11.839 2.47131C11.8175 2.35356 11.715 2.26812 11.5955 2.26812C11.595 2.26812 11.5947 2.26812 11.5942 2.26812C11.4741 2.26862 11.372 2.35517 11.3514 2.47341L9.93904 10.6108L2.74085 10.611C2.56837 10.611 2.40877 10.5397 2.29101 10.4103C2.15605 10.2616 2.08089 10.0398 2.09897 9.84978C2.15172 9.39178 2.48281 9.0592 2.88571 9.0592H8.8929C9.01362 9.0592 9.11688 8.97215 9.13694 8.85292L10.5433 0.538748C10.5554 0.46681 10.5353 0.393262 10.4882 0.337543C10.4412 0.281825 10.372 0.249756 10.2992 0.249756H4.29675C2.92744 0.249756 1.5907 1.36338 1.31669 2.73133L0.0341729 9.01103C-0.081226 9.74627 0.0978156 10.4374 0.538362 10.9576C0.970984 11.4683 1.60531 11.7497 2.32457 11.7497L2.43922 11.7493C2.44145 11.7493 2.44356 11.7494 2.44603 11.7494C2.82913 11.7498 10.1556 11.7503 10.232 11.7503C10.5092 11.7503 10.7455 11.5517 10.7945 11.2727L11.9972 3.41122C12.0015 3.38422 12.0009 3.35636 11.996 3.32949Z"
                      fill="#A0A0A4"
                    />
                  </svg>

                  {{ catalog.catalogTitles }}
                  titles
                </div>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="bg-grey-400 pt-4 px-5 pb-5 hover:shadow-sm">
          <div class="flex items-center justify-between mb-5">
            <router-link
              to="/shortlist/1/books/"
              class="
                flex
                items-center
                font-medium
                text-lg
                group
                hover:text-orange-900
              "
            >
              Shortlist of Books
              <span
                class="
                  mx-2
                  py-0.5
                  px-0.7
                  leading-none
                  rounded-xl
                  bg-black-900
                  text-white-900 text-xs
                  group-hover:bg-orange-900
                "
              >
                15
              </span>
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 9L5 5L1 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>

            <base-button colorScheme="orange" class="py-2 max-w-100">
              <span class="font-normal text-sm"> Export </span>
            </base-button>
          </div>
          <ul class="space-x-3 flex items-start">
            <li v-for="(book, i) of bookData" :key="i">
              <router-link class="block w-28" to="/">
                <div class="mb-1 w-18 min-h-115">
                  <img
                    :src="book.imageURl"
                    :alt="book.name"
                    class="shadow-md h-auto"
                  />
                </div>

                <h3
                  class="
                    text-sm text-black-900
                    font-medium
                    mb-2
                    hover:text-orange-900
                  "
                >
                  {{ book.name }}
                </h3>

                <div
                  class="
                    flex
                    items-center
                    uppercase
                    font-medium
                    text-grey-700 text-sm
                  "
                >
                  VIVIAN TEO
                </div>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="flex-shrink-0 max-w-276 flex flex-col">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-black-900 text-lg font-medium">Contacts</h3>
        <t-dropdown class="flex relative ml-2 z-10" variant="right">
          <button
            class="p-1 cursor-pointer hover:text-grey-700"
            :class="{
              'text-orange-900': shortlist.isActive,
            }"
            slot="trigger"
            slot-scope="{ mousedownHandler, blurHandler, keydownHandler }"
            @mousedown="mousedownHandler"
            @blur="blurHandler"
            @keydown="keydownHandler"
          >
            <svg
              width="18"
              height="4"
              viewBox="0 0 18 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.3048 3.56522C15.4403 3.56522 14.7396 2.86445 14.7396 2C14.7396 1.13556 15.4403 0.434784 16.3048 0.434784C17.1692 0.434784 17.87 1.13556 17.87 2C17.87 2.86445 17.1692 3.56522 16.3048 3.56522Z"
                fill="currentColor"
              />
              <path
                d="M9.00042 3.56522C8.13598 3.56522 7.43521 2.86445 7.43521 2C7.43521 1.13556 8.13598 0.434784 9.00042 0.434784C9.86487 0.434784 10.5656 1.13556 10.5656 2C10.5656 2.86445 9.86487 3.56522 9.00042 3.56522Z"
                fill="currentColor"
              />
              <path
                d="M1.69608 3.56522C0.831631 3.56522 0.130859 2.86445 0.130859 2C0.130859 1.13556 0.831631 0.434784 1.69608 0.434784C2.56052 0.434784 3.26129 1.13556 3.26129 2C3.26129 2.86445 2.56052 3.56522 1.69608 3.56522Z"
                fill="currentColor"
              />
            </svg>
          </button>

          <ul class="rounded py-2 px-3 shadow-xxs bg-white-900 w-max-content">
            <li>
              <button
                class="
                  flex
                  items-center
                  text-black-900 text-sm
                  font-medium
                  hover:text-grey-700
                  w-full
                "
              >
                <svg
                  class="mr-2 flex-shrink-0"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.22581 8.77027V18.1216C5.22581 19.7785 6.56895 21.1216 8.22581 21.1216H15.6452C17.302 21.1216 18.6452 19.7785 18.6452 18.1216V8.77027M9.87097 10.8243V16.5M14 10.8243V16.5M4 6.06757H9.16129M20 6.06757H14.8387M14.8387 6.06757V3.5C14.8387 2.94772 14.391 2.5 13.8387 2.5H10.1613C9.60901 2.5 9.16129 2.94772 9.16129 3.5V6.06757M14.8387 6.06757H9.16129"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                Delete Shortlist
              </button>
            </li>
          </ul>
        </t-dropdown>
      </div>
      <ul class="space-y-4 mb-5">
        <!-- html likethis cause don't know api structure -->
        <li>
          <h4 class="text-black-900 font-medium text-base mb-2">
            Mailing Address
          </h4>

          <div class="text-black-600 text-base leading-5">
            Epigram Books <br />
            1008 Toa Payoh North <br />
            #03-08<br />
            Singapore 318996<br />
            Our showroom is a 5-minute walk from Braddell (NS18) MRT Station.
          </div>
        </li>
        <li>
          <h4 class="text-black-900 font-medium text-base mb-2">Telephone</h4>

          <div class="text-black-600 text-base hover:text-orange-900">
            <a href="tel:(+65) 6292 4456">(+65) 6292 4456</a>
          </div>
        </li>
        <li>
          <h4 class="text-black-900 font-medium text-base mb-2">E-mail</h4>

          <div class="text-black-900 text-base">
            <a
              class="underline hover:text-orange-900"
              href="mailto:rights@epigram.sg"
              >rights@epigram.sg
            </a>
          </div>
        </li>
      </ul>
      <!-- show button if only 1 book/catalog array in shortlist -->
      <base-button v-if="false" class="mt-auto">
        <svg
          class="mr-2"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 1V11M11 6L1 6"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          />
        </svg>
        See more
      </base-button>
      <base-button colorScheme="orange" class="py-2 mt-auto">
        <span class="font-normal text-sm"> Export all </span>
      </base-button>
    </div>
  </section>
</template>

<script>
import BaseButton from "@/components/utils/Button.vue";

export default {
  name: "CardShortlist",
  components: {
    "base-button": BaseButton,
  },
  props: {
    shortlist: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // temp, while have no api

      bookData: [
        {
          name: "Book Name",
          imageURl: require("@/assets/books/1.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Book Name",
          imageURl: require("@/assets/books/2.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Book Name",
          imageURl: require("@/assets/books/3.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Book Name",
          imageURl: require("@/assets/books/4.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Book Name",
          imageURl: require("@/assets/books/5.jpg"),
          catalogTitles: 15,
        },
      ],
      catalogData: [
        {
          name: "Catalog Name",
          imageURl: require("@/assets/new-catalogs/1.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Catalog Name",
          imageURl: require("@/assets/new-catalogs/2.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Catalog Name",
          imageURl: require("@/assets/new-catalogs/3.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Catalog Name",
          imageURl: require("@/assets/new-catalogs/4.jpg"),
          catalogTitles: 15,
        },
        {
          name: "Catalog Name",
          imageURl: require("@/assets/new-catalogs/5.jpg"),
          catalogTitles: 15,
        },
      ],
    };
  },
};
</script>
